import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { inputCls, btnPrimary, errMsg } from "./shared";

export function RateRequest({ r, onRated }) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  if (r.rating) {
    return <p className="text-xs text-amber-500 font-bold mt-2" data-testid={`my-request-rated-${r.request_id}`}>You rated {"★".repeat(r.rating)}</p>;
  }
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/market/requests/${r.request_id}/rate`, { stars, comment });
      toast.success("Thanks for your rating!");
      onRated();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 rounded-2xl bg-sky-50 p-3 space-y-2" data-testid={`rate-form-${r.request_id}`}>
      <p className="text-xs font-bold text-sky-800">Rate {r.business_name}</p>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" aria-label={`${n} star${n > 1 ? "s" : ""}`} data-testid={`rate-star-${r.request_id}-${n}`} onClick={() => setStars(n)}
            className={`text-2xl leading-none transition-transform hover:scale-110 ${n <= stars ? "text-amber-400" : "text-sky-200"}`}>★</button>
        ))}
      </div>
      <input data-testid={`rate-comment-${r.request_id}`} className={inputCls} maxLength={300} placeholder="Short comment (optional)"
        value={comment} onChange={(e) => setComment(e.target.value)} />
      <button data-testid={`rate-submit-${r.request_id}`} className={`${btnPrimary} h-9`} disabled={!stars || busy} onClick={submit}>
        {busy ? "Sending…" : "Submit rating"}
      </button>
    </div>
  );
}
